// extracted by mini-css-extract-plugin
export default {"containerCabinet":"Security_containerCabinet__443Wg"};